<template>
  <div class="switch-cont">
    <div
      tabindex="0"
      class="percentage switch-label"
      :class="{ active: value === 'percentage', percentageX: value === 'decimal' }"
      @click="changeState('percentage')"
      @keypress="changeState('percentage')"
    >
      %
    </div>
    <div
      tabindex="0"
      class="decimal switch-label"
      :class="{ active: value === 'decimal', decimalX: value === 'percentage' }"
      @click="changeState('decimal')"
      @keypress="changeState('decimal')"
    >
      123
    </div>
  </div>
</template>

<script>
export default {
  name: 'RareDataFormatSwitch',
  data() {
    return {
      value: 'percentage',
    };
  },
  created() {
    if (this.$store.getters.dataFormat === '') {
      this.$store.commit('updateDataFormat', this.value);
    } else {
      this.value = this.$store.getters.dataFormat;
    }
  },

  mounted() {
  },
  methods: {
    changeState(newValue) {
      if (newValue !== this.value) {
        this.value = newValue;
        this.$store.commit('updateDataFormat', newValue);
        this.$emit('updateDataFormat', newValue);
      }
    },
  },

};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .switch-cont {
    border-radius: 20px;
    display: inline-block;
    height: 42px;
    width:120px;
  }

  .percentage {
    border: 1px solid $common-mid-grey;
    border-right: 0;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    display: inline-block;
    float: left;
    height: 40px;
    width:60px;
    text-align: center;
    font-size: 20px;
    padding-top: 3px;
  }

  .decimal {
    border: 1px solid $common-mid-grey;
    border-left: 0;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    display: inline-block;
    float: right;
    height: 40px;
    width:60px;
    text-align: center;
    font-size: 14px;
    padding-top: 8px;
  }

  .switch-label {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.71;
    letter-spacing: 2px;
  }

  /* These classes are conditionally applied if the state is NOT selected.
  So the hover effect only appears if the hovered state IS selectable */
  .percentageX:hover, .decimalX:hover {
    background-color: $header-dark-blue;
    color: $white-text;
    cursor: pointer;
  }

  .active {
    background-color: $common-mid-grey;
    color: $white-text;
    cursor: default;
  }

</style>
